import script from "./Summary.vue?vue&type=script&setup=true&lang=js"
export * from "./Summary.vue?vue&type=script&setup=true&lang=js"

import "./Summary.vue?vue&type=style&index=0&id=2776a7f5&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/PRD_sharetreats_v1_hr_company_dashboard_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2776a7f5"]])

export default __exports__